import { render, staticRenderFns } from "./Gif.vue?vue&type=template&id=4abe7eba&"
import script from "./Gif.vue?vue&type=script&lang=js&"
export * from "./Gif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports